import React from 'react';

import Switch from 'react-switch';
import infoIcon from './InfoIcon.png';
import { TOOLTIPS } from './constants';

class OverrideCallClassification extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      overrideAccountDefaults: this.props.recordAllCalls !== null,
      settingValueAll: this.props.recordAllCalls ?? this.props.parentRecordAllCalls,
      settingValuePSTN: this.props.recordPSTN ?? this.props.parentRecordPSTN,
      settingValueMeetings: this.props.recordMeetings ?? this.props.parentRecordMeetings,
      settingValueExternalParties:
        this.props.recordExternalPartyCalls ?? this.props.parentRecordExternalPartyCalls,
    };

    this.overrideAccountDefaultChanged = this.overrideAccountDefaultChanged.bind(this);
    this.onSettingSwitchAllChanged = this.onSettingSwitchAllChanged.bind(this);
    this.onSettingSwitchExternalPartiesChanged =
      this.onSettingSwitchExternalPartiesChanged.bind(this);
    this.onSettingSwitchRecordMeetingsChanged =
      this.onSettingSwitchRecordMeetingsChanged.bind(this);
    this.onSettingSwitchRecordPSTNChanged = this.onSettingSwitchRecordPSTNChanged.bind(this);
  }

  overrideAccountDefaultChanged(event) {
    this.setState({ overrideAccountDefaults: event.target.checked });
    this.props.valueChanged(
      event.target.checked,
      this.state.settingValueAll,
      this.state.settingValueExternalParties,
      this.state.settingValueMeetings,
      this.state.settingValuePSTN
    );
  }

  onSettingSwitchAllChanged(checked) {
    if (checked) {
      this.setState({
        settingValueExternalParties: false,
        settingValueMeetings: false,
        settingValuePSTN: false,
      });
    }
    this.setState({ settingValueAll: checked });
    this.props.valueChanged(
      this.state.overrideAccountDefaults,
      checked,
      this.state.settingValueExternalParties || checked,
      this.state.settingValueMeetings || checked,
      this.state.settingValuePSTN || checked
    );
  }

  onSettingSwitchExternalPartiesChanged(checked) {
    if (!checked) {
      this.setState({ settingValueAll: false });
    }
    this.setState({ settingValueExternalParties: checked });
    this.props.valueChanged(
      this.state.overrideAccountDefaults,
      this.state.settingValueAll && checked,
      checked,
      this.state.settingValueMeetings,
      this.state.settingValuePSTN
    );
  }

  onSettingSwitchRecordMeetingsChanged(checked) {
    if (!checked) {
      this.setState({ settingValueAll: false });
    } else {
      this.setState({ settingValueExternalParties: true, settingValuePSTN: true });
    }
    this.setState({ settingValueMeetings: checked });
    this.props.valueChanged(
      this.state.overrideAccountDefaults,
      this.state.settingValueAll && checked,
      this.state.settingValueExternalParties,
      checked,
      this.state.settingValuePSTN
    );
  }

  onSettingSwitchRecordPSTNChanged(checked) {
    if (!checked) {
      this.setState({ settingValueAll: false });
    } else {
      this.setState({ settingValueExternalParties: true, settingValueMeetings: true });
    }
    this.setState({ settingValuePSTN: checked });
    this.props.valueChanged(
      this.state.overrideAccountDefaults,
      this.state.settingValueAll && checked,
      this.state.settingValueExternalParties,
      this.state.settingValueMeetings,
      checked
    );
  }

  render() {
    return (
      <div className="vertical-settings">
        <div className="setting">
          <div className="override-label">Override Account Default</div>
          <div className="settingCheckbox">
            <input
              type="checkbox"
              onChange={this.overrideAccountDefaultChanged}
              defaultChecked={this.state.overrideAccountDefaults}
              id="useAccountDefaultsPauseResume"
            />
          </div>
          <div className="switch-label">
            <img src={infoIcon} alt="info" title={TOOLTIPS.RECORD_ALL_CALLS} />
            <label htmlFor="settingSwitchAll">Record All Calls</label>
          </div>
          <Switch
            id="settingSwitchAll"
            borderRadius={9}
            height={18}
            width={36}
            disabled={!this.state.overrideAccountDefaults}
            onChange={this.onSettingSwitchAllChanged}
            checked={
              this.state.overrideAccountDefaults
                ? this.state.settingValueAll
                : this.props.parentRecordAllCalls
            }
          />
        </div>
        <div className="setting">
          <div>
            <div className="override-label"></div>
            <div className="settingCheckbox"></div>
          </div>
          <div className="switch-label switch-separator">----- OR -----</div>
        </div>
        <div className="setting">
          <div className="override-label"></div>
          <div className="settingCheckbox"></div>
          <div className="switch-label">
            <img src={infoIcon} alt="info" title={TOOLTIPS.RECORD_EXTERNAL_CALLS} />
            <label htmlFor="settingSwitchExternalParties">Record External Calls</label>
          </div>
          <Switch
            id="settingSwitchExternalParties"
            borderRadius={9}
            height={18}
            width={36}
            disabled={!this.state.overrideAccountDefaults}
            onChange={this.onSettingSwitchExternalPartiesChanged}
            checked={
              this.state.overrideAccountDefaults
                ? this.state.settingValueExternalParties
                : this.props.parentRecordExternalPartyCalls
            }
          />
        </div>
        <div className="setting">
          <div className="override-label"></div>
          <div className="settingCheckbox"></div>
          <div className="switch-label">
            <img src={infoIcon} alt="info" title={TOOLTIPS.RECORD_MEETINGS} />
            <label htmlFor="settingSwitchRecordMeetings">Record Meetings</label>
          </div>
          <Switch
            id="settingSwitchRecordMeetings"
            borderRadius={9}
            height={18}
            width={36}
            disabled={!this.state.overrideAccountDefaults}
            onChange={this.onSettingSwitchRecordMeetingsChanged}
            checked={
              this.state.overrideAccountDefaults
                ? this.state.settingValueMeetings
                : this.props.parentRecordMeetings
            }
          />
        </div>
        <div className="setting">
          <div className="override-label"></div>
          <div className="settingCheckbox"></div>
          <div className="switch-label">
            <img src={infoIcon} alt="info" title={TOOLTIPS.RECORD_PSTN} />
            <label htmlFor="settingSwitchRecordPstn">Record PSTN</label>
          </div>
          <Switch
            id="settingSwitchRecordPstn"
            borderRadius={9}
            height={18}
            width={36}
            disabled={!this.state.overrideAccountDefaults}
            onChange={this.onSettingSwitchRecordPSTNChanged}
            checked={
              this.state.overrideAccountDefaults
                ? this.state.settingValuePSTN
                : this.props.parentRecordPSTN
            }
          />
        </div>
      </div>
    );
  }
}

export { OverrideCallClassification };
